import React, { Component } from 'react';
import { Button, Table, Segment, Header, Form, List, Dimmer, Loader }
	from 'semantic-ui-react'
import Search from '../components/search';
import userstore from '../store/user-store';
import {observer} from 'mobx-react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import ReactTable from "react-table";
import * as mobx from 'mobx';



class User extends Component {

  constructor(props) {
  	super(props);
  	this.state = {
  		visible: false
  	}
  }


  componentDidMount() {
  	userstore.loadAllUsers();
   }

  toggleVisibility = () => this.setState({ visible: !this.state.visible })

  handleChange = (e, { value }) => this.setState({ value })

  renderList() {
  	return (
  		 <List>
					{userstore.users.map(i =>
					 	<List.Item key={i.username}>
					 		<Header className="list-icon">{i.username}</Header>
					 		<List.Content>
				                        </List.Content>
					 	</List.Item>
					 )}
  		 		}
		  </List>
  	)
  }

  renderReactTable() {
		const users = mobx.toJS(userstore.filteredUsers);

		return(
				<ReactTable
					data={users}
					noDataText="No records found"
					 //filterable
         			 //defaultFilterMethod={(filter, row) =>
           			 //String(row[filter.id]) === filter.value}
					columns = {[
						{ Header: "Username", accessor: "username", Cell: props => {
							const { original } = props;
							return (<Link to={"/user/" + original.userid}>{original.username}</Link>)
						}
						},
						{ Header: "Firt Name", accessor: 'firstname' },
						{ Header: "Last Name", accessor: 'lastname' },
						{ Header: "Email Address", accessor: 'email' },
						{ Header: "Org Name", accessor: "orgname"},
						{ Header: "Work Phone#", accessor: "workphone"},
						{ Header: "Active Flag", accessor: "activeflag", width: 80},
					]}
					style={{
						height: '80vh'
					}}
					defaultPageSize={25}
					//className="-striped -highlight"
					showPaginationTop={true}
					showPaginationBottom={false}
				/>

		)

	}


  render() {
        return(
	            <div className="user-actions">

	        	    <div className="title">
	                   <h4 align="left">User Management</h4>
	                </div>

            		<Button inverted primary> <Link to={"/usercreate"}> Create User </Link> </Button>

            		 {userstore.loading && (
				          <Segment>
				            <Dimmer active inverted>
				              <Loader inverted>Loading</Loader>
				            </Dimmer>
				          </Segment>
				      )}

					 {this.renderReactTable()}

	            </div>
              )
  }
}

export default observer(User);



// WEBPACK FOOTER //
// ./src/containers/User.js